<svelte:options accessors />

<script>
  export let value = "";
  export let placeholder = "";
  export let autocomplete = "on";
  export let name = "";

  let inputRef;
</script>

<div class="font-[Open\ Sans] w-full">
  <input
    type="text"
    placeholder={placeholder}
    autocomplete={autocomplete}
    name={name}
    class="section_textfield {$$restProps.class}"
    bind:value={value}
    bind:this={inputRef}
    on:input
  />
</div>
